import React from "react";
import { useTranslation } from "react-i18next";
import RecoveryTable from "../components/trash_page/RecoveryTable";
import {
  Breadcrumbs,
  BreadcrumbItem,
  Button,
  useDisclosure,
} from "@nextui-org/react";
import { Alert } from "antd";
import EmptyTrashModal from "src/components/modals/EmptyTrashModal";
import useListAllTrash from "src/hooks/useListAllTrash";

const Recovery: React.FC = () => {
  const { t } = useTranslation();
  const {
    isOpen: isEmptyTrashOpen,
    onOpen: onOpenEmptyTrashOpen,
    onClose: onCloseEmptyTrashOpen,
  } = useDisclosure();
  const { totalItems } = useListAllTrash();

  const handleEmptyTrash = () => {
    onOpenEmptyTrashOpen();
  };

  return (
    <>
      <div className="text-[33px] capitalize text-navy-700 mt-4 mb-5">
        <div className="font-bold capitalize hover:text-navy-700">
          <div className="flex justify-between">
            <span>{t("Recovery")}</span>

            <div>
              {totalItems > 0 && (
                <Button
                  className="bg-success text-background"
                  size="sm"
                  onClick={handleEmptyTrash}
                >
                  {t("EmptyTrash")}
                </Button>
              )}
            </div>
          </div>
        </div>

        {/* Breadcrumbs */}
        <Breadcrumbs isDisabled className="mb-5">
          <BreadcrumbItem>{t("SAFFCLOUD")}</BreadcrumbItem>
          <BreadcrumbItem>{t("Recovery")}</BreadcrumbItem>
        </Breadcrumbs>
        <Alert
          message={t("ItemsWillBePermanentlyDeleted")}
          className="bg-[#4b65bc2a] border-[#4b65bc2a] my-5 text-red-600 font-bold capitalize-first-letter"
        />
      </div>

      <div>
        <RecoveryTable />
      </div>

      <EmptyTrashModal
        isOpen={isEmptyTrashOpen}
        onClose={onCloseEmptyTrashOpen}
      />
    </>
  );
};

export default Recovery;
